import { render, staticRenderFns } from "./supplyBoat.vue?vue&type=template&id=fe63430a&"
import script from "./supplyBoat.vue?vue&type=script&lang=js&"
export * from "./supplyBoat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports